<template>
  <div>
    <el-card style="margin-bottom: 25px" shadow="always">
      <div slot="header" class="clearfix" style="display: flex;justify-content: space-between; align-items: center">
        <span>Карта тональности</span>
        <label>
          <span style="margin-right: 15px">Фильтр по тональности</span>
          <el-select v-model="tonal" placeholder="Фильтр по тональности">
            <el-option
              v-for="item in filterOptions"
              :key="item.title"
              :label="item.title"
              :value="item.value">
            </el-option>
          </el-select>
        </label>
      </div>
      <ymap :coords="userCityMapCoords" :balloons="filteredBalloons" @showPosts="showPosts" v-if="active"></ymap>
    </el-card>

    <el-dialog title="Посты события" :visible.sync="dialogEventPostsVisible">
      <div class="dialog-event-posts" v-loading="postLoad">
        <posts
          v-if="posts.length"
          v-loading="loading"
          :posts="posts"
          @loadPosts="loadPosts"
          @showMore="showMore"
          @toggleComment="toggleComment"
          @setTrust="setTrust"
          @addStopPost="addStopPost"
          :excluded="true"
        />
        <span v-if="postEmpty">
          В данном событии пока нет постов.
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // components
  import Ymap from "@/components/yMap/YmapTonal";
  import Posts from '../publicationsAndComments/components/Posts';
  // api
  import { getEventsApi, getEventPostsApi } from '../../../../../../api/events';
  import { setPostsTrustApi } from '@/api/publications';

  // vuex
  import { mapGetters } from 'vuex';

  export default {
    name: "TonalMap",
    props: {
      active: {
        type: Boolean
      }
    },
    data() {
      return {
        filterOptions: [
          {
            title: 'Все',
            value: null
          },
          {
            title: 'Позитив',
            value: 1
          },
          {
            title: 'Нейтрал',
            value: 0
          },
          {
            title: 'Негатив',
            value: -1
          }
        ],
        tonal: null,
        dialogEventPostsVisible: false,
        loading: false,
        postLoad: false,
        balloons: [],
        posts: [],
        limit: 30,
        start: 0,
        postEmpty: false,
        activeEventId: 0
      };
    },
    computed: {
      ...mapGetters([
        'userId',
        'userCityMapCoords'
      ]),
      filteredBalloons() {
        if(this.tonal !== null) {

          if (this.tonal > 0) {
            return this.balloons.filter(item => item.stats.trust.coefficient > 0);
          }

          if (this.tonal === 0) {
            return this.balloons.filter(item => item.stats.trust.coefficient === 0);
          }

          if (this.tonal < 0) {
            return this.balloons.filter(item => item.stats.trust.coefficient < 0);
          }
        }
        return this.balloons;
      }
    },
    methods: {
      loadPosts() {
        this.getPosts();
      },
      showMore(post) {
        post.showMore = !post.showMore;
      },
      toggleComment(post){
        if (post.showComment === undefined) {
          this.$set(post, 'showComment', true);
          this.$set(post, 'firstLoad', true);
        } else {
          post.showComment = !post.showComment;
          post.firstLoad = false;
        }
      },
      setTrust({postId, trust}) {
        const post = this.posts.find(item => item.id === postId);

        const params = {
          post_id: postId,
          owner_id: post.owner_id,
          network_id: post.network_id,
          trust: trust
        };

        setPostsTrustApi(params).then(() => {
          this.posts = this.posts.map(item => {
            if (item.id === postId) {
              item.trust.trust = trust;
            }

            return item;
          });
        });
      },
      addStopPost(){},
      getParams(){
        return {
          "event_id": this.activeEventId,
          "from": "",
          "to": "",
          "start": this.start,
          "limit": this.limit
        };
      },
      getPosts(){
        this.postLoad = true;
        this.dialogEventPostsVisible = true;

        getEventPostsApi(this.getParams()).then((resp) => {
          if (resp.data.posts.length) {
            const postsData = resp.data.posts.map(item => {
              return { ...item, showMore: false };
            });

            this.posts = [...this.posts, ...postsData];
            this.start = this.start + postsData.length;
          }
          if (!this.posts.length) {
            this.postEmpty = true;
          }
          this.postLoad = false;
        });
      },
      showPosts(payload) {
        let activeEventId = this.balloons.find(item => item.id === Number(payload.split('=')[1])).id;

        this.posts = [];
        this.postEmpty = false;
        this.activeEventId = activeEventId;

        this.start = 0;
        this.getPosts();
      },
      getEvents() {
        this.loading = true;
        let params = {
          user_id: this.userId,
          from: '',
          to: ''
        };

        getEventsApi(params).then(resp => {
          this.balloons = resp.data.filter(item => item.coord_line !== '');
          this.loading = false;
        });
      },
    },
    mounted() {
      this.getEvents();
    },
    components: {
      Ymap,
      Posts
    },
    watch: {
      dialogEventPostsVisible(value) {
        if(!value) {
          this.$router.go(-1)
        }
      }
    }
  };
</script>

<style>
  .dialog-event-posts {
    min-height: 150px;
  }
</style>
